import React from 'react';
import { useSelector } from 'react-redux';

import { isContratante, isOldAdmin } from '../../../utils/userRole';

// #region Importação Componentes
import LoadingSpinning from '../../molecules/LoadingSpinning';
import {
  TabActionWrapper,
  TabButton,
  TabContainer,
  TabContentWrapper,
} from '../../molecules/Tab';
import ParametrizacaoContratantes from '../ParametrizacaoContratantes';
import CadastroWebhook from './CadastroWebhook';
import DadosAcesso from './DadosAcesso';
import DadosGerais from './DadosGerais';
import EmptyContent from './EmptyContent';
// #endregion

function TabsFormConfiguracoes({
  usuarioParams,
  setUsuarioParams,
  contatoParams,
  setContatoParams,
  dadosAcessoParams,
  setDadosAcessoParams,
  usuarioDadosGerais,
  usuarioDadosAcesso,
  handleAcaoUsuarioById,
  handleActiveTab,
  disableNameInput,
  useField,
}) {
  const {
    accessToken,
    usuario: { idUsuarioLogado, role },
  } = useSelector((state) => state.auth);

  const errorSenha = useField('senha').error;
  const errorNovaSenha = useField('novaSenha').error;
  const errorConfirmacaoSenha = useField('confirmacaoSenha').error;

  function handleRenderTable(tabName = null) {
    if (usuarioDadosGerais.loading) {
      return <LoadingSpinning />;
    }
    if (usuarioDadosGerais.response) {
      return (
        <DadosGerais
          usuarioParams={usuarioParams}
          setUsuarioParams={setUsuarioParams}
          contatoParams={contatoParams}
          setContatoParams={setContatoParams}
          usuarioDadosGerais={usuarioDadosGerais.response}
          disableNameInput={disableNameInput}
          useField={useField}
        />
      );
    }
    return <EmptyContent />;
  }

  return (
    <>
      <TabContainer>
        <TabActionWrapper>
          <TabButton
            key="dadosGerais"
            active
            color="#00995D"
            name="dadosGerais"
            text="Dados gerais"
            widthAuto
            onClick={() => handleActiveTab('dadosGerais')}
          />
          <TabButton
            key="dadosAcesso"
            color="#00995D"
            name="dadosAcesso"
            text="Dados de acesso"
            widthAuto
            onClick={() => handleActiveTab('dadosAcesso')}
          />
          {!isOldAdmin(accessToken) && !isContratante(role) && (
            <TabButton
              key="parametros"
              color="#00995D"
              name="parametros"
              text="Parâmetros"
              widthAuto
              onClick={() => handleActiveTab('parametros')}
            />
          )}
          <TabButton
            key="cadastroWebhook"
            color="#00995D"
            name="cadastroWebhook"
            text="Cadastro de Webhook"
            widthAuto
            onClick={() => handleActiveTab('cadastroWebhook')}
          />
        </TabActionWrapper>
        <TabContentWrapper
          maxHeight="none"
          height="auto"
          active
          contentFor="dadosGerais"
        >
          {handleRenderTable()}
        </TabContentWrapper>
        <TabContentWrapper
          maxHeight="none"
          height="auto"
          contentFor="dadosAcesso"
        >
          <DadosAcesso
            usuarioParams={usuarioParams}
            dadosAcessoParams={dadosAcessoParams}
            setDadosAcessoParams={setDadosAcessoParams}
            usuarioDadosAcesso={usuarioDadosAcesso}
            handleAcaoUsuarioById={handleAcaoUsuarioById}
            errorSenha={errorSenha}
            errorNovaSenha={errorNovaSenha}
            errorConfirmacaoSenha={errorConfirmacaoSenha}
          />
        </TabContentWrapper>
        {!isOldAdmin(accessToken) && !isContratante(role) && (
          <TabContentWrapper
            maxHeight="none"
            height="auto"
            contentFor="parametros"
          >
            <ParametrizacaoContratantes
              idUsuario={idUsuarioLogado}
              roleUsuario={role}
            />
          </TabContentWrapper>
        )}
        <TabContentWrapper
          maxHeight="none"
          height="auto"
          contentFor="cadastroWebhook"
        >
          <CadastroWebhook />
        </TabContentWrapper>
      </TabContainer>
    </>
  );
}

export default TabsFormConfiguracoes;
